const DeliveryMethod = [
  {
    path: '/ecommerce/settings',
    name: 'delivery_method',
    component: () => import(/* webpackChunkName: "delivery_method" */ '../views/DeliveryMethodView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Delivery Methods',
          path: '/settings/delivery-methods',
        },
      ],
    },
    children: [
      {
        path: 'delivery-methods',
        name: 'delivery_methods',
        component: () => import(/* webpackChunkName: "delivery_method" */ '../components/DeliveryMethod/DeliveryMethods.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Delivery Methods',
              path: '/ecommerce/settings/delivery-methods',
            },
          ],
        },
      },
      {
        path: 'delivery-methods/new',
        name: 'new_delivery_method',
        component: () => import(/* webpackChunkName: "delivery_method_new" */ '../components/DeliveryMethod/NewDeliveryMethod.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'New Delivery Method',
              path: '/ecommerce/settings/delivery-methods/new',
            },
          ],
        },
      },
      {
        path: 'delivery-methods/:id/details',
        name: 'delivery_method_details',
        component: () => import(/* webpackChunkName: "delivery_method_details" */ '../components/DeliveryMethod/DeliveryMethodDetails.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Delivery Method Details',
              path: '/ecommerce/settings/delivery-methods/:id/details',
            },
          ],
        },
      },
      {
        path: 'delivery-methods/:id/edit',
        name: 'edit_delivery_method',
        component: () => import(/* webpackChunkName: "delivery_method_edit" */ '../components/DeliveryMethod/UpdateDeliveryMethod.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Edit Delivery Method',
              path: '/ecommerce/settings/delivery-methods/:id/edit',
            },
          ],
        },
      },
    ],
  },
];

export default DeliveryMethod;
